import {
  DailyPerformanceDto,
  EmployeePerformanceDto,
  GetBranchDailyDemographicsDto,
  GetBranchDailyDemographicsV2Dto,
  ReportApiFp,
  ReportControllerBranchDailyDemographics200Response,
  ReportControllerBranchDailyDemographicsV2200Response,
  ReportControllerDailyPerformance200Response,
  ReportControllerGetLateRanking200Response,
  ReportControllerPerfomanceRanking200Response,
} from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export type GetBranchDailyResponseModel =
  ReportControllerBranchDailyDemographics200Response;
export type GetBranchDailyResponseModelV2 =
  ReportControllerBranchDailyDemographicsV2200Response;

export type GetBranchDailyModel = GetBranchDailyDemographicsDto;
export type GetBranchDailyModelV2 = GetBranchDailyDemographicsV2Dto;
export type GetDailyPerformanceResponseModel =
  ReportControllerDailyPerformance200Response;
export type GetPerformanceRankingResponseModel =
  ReportControllerPerfomanceRanking200Response;
export type GetDailyPerformanceModel = DailyPerformanceDto;
export type EmployeePerformanceModel = EmployeePerformanceDto;

export type GetLateRankingResponse = ReportControllerGetLateRanking200Response;

export const apiReportFp = ReportApiFp(apiConfig);
export const getBranchDaily =
  apiReportFp.reportControllerBranchDailyDemographics;
export const getBranchDailyV2 =
  apiReportFp.reportControllerBranchDailyDemographicsV2;
export const getDailyPerformance = apiReportFp.reportControllerDailyPerformance;
export const getPerformanceRanking =
  apiReportFp.reportControllerPerfomanceRanking;
export const getLateRanking = apiReportFp.reportControllerGetLateRanking;
export const getOvertimeRanking =
  apiReportFp.reportControllerGetOvertimeRanking;
export const getAbsentRanking = apiReportFp.reportControllerGetAbsentRanking;
export const getAmendedRanking =
  apiReportFp.reportControllerGetAmendmentRanking;
export const getLeaveRanking = apiReportFp.reportControllerGetLeaveRanking;
export const getUndertimeRanking =
  apiReportFp.reportControllerGetUndertimeRanking;

export const QueryKeyReportBranchDaily = QueryKey.ReportBranchDaily;
export const QueryKeyReportDailyPerformance = QueryKey.ReportDailyPerformance;
export const QueryKeyReportPerformanceRanking =
  QueryKey.ReportPerformanceRanking;
export const QueryKeyReportGetLateRanking = QueryKey.ReportGetLateRanking;
export const QueryKeyReportGetOvertimeRanking =
  QueryKey.ReportGetOvertimeRanking;
export const QueryKeyReportGetAbsentRanking = QueryKey.ReportGetAbsentRanking;
export const QueryKeyReportGetAmendRanking = QueryKey.ReportGetAmendRanking;
export const QueryKeyReportGetLeaveRanking = QueryKey.ReportGetLeaveRanking;
export const QueryKeyReportGetUndertimeRanking =
  QueryKey.ReportGetUndertimeRanking;
